export type Pagination = {
  page: number
  itemsPerPage: number
}

export type OptionalPagination = {
  page?: number
  itemsPerPage?: number
}

export type ApiResponse = {
  success: boolean
  callbackUrl?: string
  code?: number
  error?: string
}

export const WHO_AM_I: number = 13

export enum FileType {
  VIDEO_EDITED = 'VIDEO_EDITED',
  VIDEO_RAW = 'VIDEO_RAW',
  ATTACHMENT = 'ATTACHMENT',
  QUESTION_IMAGE = 'QUESTION_IMAGE',
  ATTACHMENT_EXAM = 'ATTACHMENT_EXAM',
  CONTENT_FAKE = 'CONTENT_FAKE',
  EXAM_ICON = 'EXAM_ICON',
  IMAGE_COMMENTS = 'IMAGE_COMMENTS',
  IMAGE_FROM_NOTIFICATIONS = 'IMAGE_FROM_NOTIFICATIONS',
  IMAGE_EDITOR = 'IMAGE_EDITOR',
  IMAGE_FROM_PROMOTIONS = 'IMAGE_FROM_PROMOTIONS',
  IMAGE_FROM_QUESTION_CORRECTION = 'IMAGE_FROM_QUESTION_CORRECTION',
}

export enum FileHost {
  DIGITALOCEAN_S3 = 'DIGITALOCEAN_S3',
  BUNNY_STREAM = 'BUNNY_STREAM',
  BUNNY_STORAGE = 'BUNNY_STORAGE',
}
